import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ProbationPeriodDTO } from 'src/app/core/api/v1';
import { FullNamePipe } from 'src/app/shared/pipes/full-name.pipe';
import { DateToTimeRemainingPipe } from '../../../pipes/date-to-time-remaining.pipe';
import { DateComputePipe } from '../../../pipes/date-compute.pipe';

@Component({
  selector: 'pp-probation-notification-body',
  imports: [TableModule, FullNamePipe, DateToTimeRemainingPipe, DateComputePipe, DatePipe],
  templateUrl: './probation-notification-body.component.html',
  styleUrl: './probation-notification-body.component.scss'
})
export class ProbationNotificationBodyComponent {
  @Input() data: ProbationPeriodDTO[] = [];
  today: Date = new Date();
}
